
import SwiperInit from './parts/swiperInit'
document.addEventListener('DOMContentLoaded', () => { 
  const scoresSelector = document.querySelectorAll('.scores-swiper')
  const scoreSwiper = new SwiperInit({
    selector: scoresSelector,
    spaceBetween: 20,
    slidesPerView: 4,
    autoplay: {delay:3000},
    breakPoints: {
      280: {
        centeredSlides: true,
        slidesPerView: 1, 
        spaceBetween: 16,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      },
      576: {
        centeredSlides: false,
        slidesPerView: 2, 
        spaceBetween: 16,
        effect: false
      },
      992: {
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        centeredSlides: false,
        slidesPerView: 4,
        noSwipingClass: 'no-swipe',
      }
    }
  })
})
